import { LoginForm } from "@/components/login-form";
import LayoutAuth from "@/layouts/AuthLayout";
import { usePocket } from "@/contexts/PocketContext";
import { useEffect } from "react";
import { navigate } from "vike/client/router";

export default function AuthPage() {
  const { user } = usePocket();
  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);
  return (
    <LayoutAuth>
      <LoginForm />
    </LayoutAuth>
  );
}
